module.exports = __webpack_public_path__ + "img/Monk.9e4a1cbb.png";